import { setDarkMode, themeAtom } from '@src/store/theme/theme';
import { useAtomValue } from 'jotai';
import type { FC } from 'react';
import Icon from '../../basic-components/Icon/Icon';

export interface DarkModeToggleProps {
    href?: string;
    className?: string;
    onClick?: () => void;
}

const DarkModeToggle: FC<DarkModeToggleProps> = props => {
    const { onClick, className } = props;
    const { isDarkModeOn } = useAtomValue(themeAtom);

    function renderLightIcon() {
        const iconClassName = isDarkModeOn ? 'text-gray-500' : 'text-primary-500';
        return <Icon onClick={() => setDarkMode(false)} className={`transition cursor-pointer ${iconClassName}`} name="sun" />;
    }

    function renderDarkIcon() {
        const iconClassName = isDarkModeOn ? 'text-gray-50' : 'text-gray-900';
        return <Icon onClick={() => setDarkMode(true)} className={`transition cursor-pointer ${iconClassName}`} name="moon" />;
    }

    function renderSeparator() {
        return <div className={`transition text-sm mx-1 ${className}`}>\</div>;
    }

    return (
        <div className={`text-xl text-gray-500 rounded-xl h-7 flex items-center px-2 transition bg-gray-200 dark:bg-gray-800 ${className}`} onClick={onClick}>
            {renderLightIcon()}
            {renderSeparator()}
            {renderDarkIcon()}
        </div>
    );
};

export default DarkModeToggle;
